/* unplugin-vue-components disabled */import { render } from "./nomenu.vue?vue&type=template&id=612e9286"
import script from "./nomenu.vue?vue&type=script&lang=js"
export * from "./nomenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__